import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Card, CardBody, Col, Row} from "reactstrap";
import Parser from "react-html-parser";
import setAuthorizationHeader from "utils/setAuthorizationHeader";
import ListGroupItemHeading from "reactstrap/es/ListGroupItemHeading";
import ListGroupItem from "reactstrap/es/ListGroupItem";
import ListGroup from "reactstrap/es/ListGroup";
import NextSurveys from "../Survey/components/NextSurveys";

class ErrorPage extends PureComponent {

  componentDidMount() {
    if(this.props.responseError.status === 403 && this.props.responseError.data.forceLogout){
      localStorage.removeItem('jwt');
      setAuthorizationHeader();

      window.location.reload();
    }
  }

  render() {
    const {responseError} = this.props;

    return (
      <Row className="justify-content-center">
        <Col xs={12} lg={8}>
          <Card className={"invitation-card"}>
            <CardBody className="invitation-text">
              <h1 className="w-100">Nie można wypełnić tej ankiety</h1>
              <span>{Parser(responseError.data.msg)}</span>

              {responseError.data.user && <React.Fragment>
                <ListGroup className="mt-4">
                  <ListGroupItemHeading tag="p">Aktualna liczba punktów na Twoim koncie</ListGroupItemHeading>
                  <ListGroupItem>CashPoints: {responseError.data.user.cashPoints}</ListGroupItem>
                  <ListGroupItem>SocialPoints: {responseError.data.user.socialPoints}</ListGroupItem>
                </ListGroup>
                <div>
                  <a href={process.env.PANEL_HOST + "/logowanie"} style={{display: 'block', margin: '50px 0'}}>Przejdź do swojego konta w swpanel.pl</a>
                </div>
              </React.Fragment>}

              {responseError.data.nextSurveys && responseError.data.nextSurveys.length > 0 && <NextSurveys nextSurveys={responseError.data.nextSurveys}/>}
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}

ErrorPage.propTypes = {
  responseError: PropTypes.shape({
    data: PropTypes.shape({
      msg: PropTypes.string,
    }).isRequired,
    status: PropTypes.oneOf([404, 403]).isRequired,
  }).isRequired,
};

export default ErrorPage;